'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _modal = require('../../../redux/modules/modal');

var _createAccount = require('../../../redux/modules/createAccount');

var _browser = require('../../../redux/modules/browser');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _analytics = require('../../../redux/modules/analytics');

var _bidderExists = require('../../../redux/modules/bidderExists');

var _whiteLabel = require('../../../redux/modules/whiteLabel');

var _enums = require('../../../enums');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpModal = require('./SignUpModal');

var _SignUpModal2 = _interopRequireDefault(_SignUpModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var attributionData = (0, _analytics.getAttributionData)(state);
    var bidderExists = (0, _bidderExists.getBidderExists)(state);

    var _getCreateAccountStat = (0, _createAccount.getCreateAccountState)(state),
        error = _getCreateAccountStat.error,
        submitted = _getCreateAccountStat.submitted,
        success = _getCreateAccountStat.success;

    var isMobile = !!(0, _browser.isUiMobile)(state);
    var isTablet = (0, _browser.isUiTablet)(state);
    var openModal = (0, _modal.getOpenModal)(state);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);

    return {
        attributionData: attributionData,
        bidderExists: bidderExists,
        error: error,
        isMobile: isMobile,
        isTablet: isTablet,
        openModal: openModal,
        submitted: submitted,
        success: success,
        whiteLabel: whiteLabel
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        dismissModal: _modal.dismissModal,
        openLoginModal: _modal.openLoginModal,
        openSetPasswordModal: _modal.openSetPasswordModal,
        submitCreateAccount: _createAccount.submitCreateAccount
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(SignUpContainer, _Component);

    function SignUpContainer(props, context) {
        (0, _classCallCheck3.default)(this, SignUpContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignUpContainer.__proto__ || (0, _getPrototypeOf2.default)(SignUpContainer)).call(this, props, context));

        _this.setEmail = function (email) {
            _this.setState({ email: email });
        };

        _this.submitCreateAccount = function (email) {
            _this.props.submitCreateAccount(email, _this.props.attributionData);
        };

        _this.cancelSignUp = function () {
            _this.props.dismissModal();
        };

        _this.state = {
            email: ''
        };
        return _this;
    }

    (0, _createClass3.default)(SignUpContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['attributionData', 'bidderExists', 'error', 'openModal', 'submitted', 'success', 'whiteLabel']) || (0, _propsComparer2.default)(this.state, nextState, ['email']);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                bidderExists = _props.bidderExists,
                success = _props.success;


            if (success && !prevProps.success) {
                this.props.openSetPasswordModal();
            } else if (bidderExists && !prevProps.bidderExists) {
                this.props.openLoginModal();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var show = this.props.openModal === _enums.modalTypes.SIGN_UP;
            var _props2 = this.props,
                bidderExists = _props2.bidderExists,
                error = _props2.error,
                isMobile = _props2.isMobile,
                isTablet = _props2.isTablet,
                submitted = _props2.submitted,
                whiteLabel = _props2.whiteLabel;


            return (0, _jsx3.default)(_SignUpModal2.default, {
                bidderExists: bidderExists,
                cancelSignUp: this.cancelSignUp,
                error: error,
                isMobile: isMobile,
                isTablet: isTablet,
                openLoginModal: this.props.openLoginModal,
                setEmail: this.setEmail,
                show: show,
                submitCreateAccount: this.submitCreateAccount,
                submitted: submitted,
                whiteLabel: whiteLabel
            });
        }
    }]);
    return SignUpContainer;
}(_react.Component)) || _class);
exports.default = SignUpContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/SignUpModal/SignUpModalContainer.js
// module id = KmPa
// module chunks = 57